module.exports = __webpack_public_path__ + "img/holiday.be9e1e8b.png";